import React from "react";

function TableHeader(props) {
    return (
        <thead className="table-dark table-header">
            <tr>
                <th>Číslo SP</th>
                <th>Produkty</th>
                <th>SN</th>
                <th>Názov Prípadu</th>
                <th>Zákazník</th>
                <th>Stav</th>
                <th>Trvanie (dni)</th>
            </tr>
        </thead>
    )
}

export default TableHeader
